export default function makeKey(seriesInstanceUID, modality) {
  if (typeof seriesInstanceUID !== "string" || typeof modality !== "string") {
    throw new Error("type is not string in makeKey");
  }

  let seriesInstanceKey = seriesInstanceUID || "NoneSeriesUID";
  let modalityKey = modality || "NoneModality";

  const key = seriesInstanceKey + "_" + modalityKey;

  return key;
}
